import React from 'react'
import { connect } from 'react-redux'


class FilePage extends React.Component {

  render() {
    const { mission_page } = this.props
    return (
      <div>
        {`FilePage ${mission_page.id}`}
      </div>
    )
  }

}

FilePage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(FilePage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FilePage/index.jsx